import { createContext, useContext } from 'react';

/**
 * The context and the hooks that read it, kept apart from the provider.
 *
 * Not a style preference: a file that exports both a component and other
 * values loses React Fast Refresh, so every content edit in dev would reload
 * the page and lose the route you were on. Splitting them keeps the reload
 * scoped to the component that changed.
 */

export const SiteContentContext = createContext({
  content: {},
  status: 'loading',
  locale: 'fa',
});

/** Everything, for a page that needs several sections. */
export function useSiteContent() {
  return useContext(SiteContentContext);
}

/**
 * One section, already merged over its defaults.
 *
 * @example
 *   const hero = useSection('hero');
 *   <h1>{hero.headline}</h1>
 */
export function useSection(name) {
  const { content } = useContext(SiteContentContext);
  return content[name] || {};
}

/** A section's repeating list, guaranteed to be an array. */
export function useSectionList(name, key = 'items') {
  const section = useSection(name);
  const list = section[key];
  return Array.isArray(list) ? list : [];
}
